import 'bootstrap'
import '../sass/main.scss'

import Loader from './components/Loader';
import SelectBox from './components/SelectBox';
import Video from './components/Video';
import Player from './components/Player';
import { TweenMax, CSSPlugin, easeOut, Back } from 'gsap/all';
import { tns } from 'tiny-slider/src/tiny-slider.module';
import { tagsinput } from  'bootstrap-tagsinput';
import $ from "jquery";
import './../../public/admin_res/js/typeahead';
import './components/jquery.flexdatalist';
import './components/jquery.mask.min';

Loader();

//Video();

document.addEventListener('DOMContentLoaded', () => {

    if(document.querySelector('.carousel')) {
        var slider = tns({
            container: '.carousel',
            items: 1,
            autoplay: true,
            speed: 1200,
            autoplayTimeout: 10000,
            autoplayHoverPause: true
        });
    }

    // mask

    // Ricerca
    var cerca = document.querySelector('.search-btn');
    var cercaBox = document.querySelector('.ricerca');
    var cercaTL = new TimelineMax({ paused: true, reversed: true })
        .to('.search-icon', 0.2, { scale: 0, ease: Cubic.easeOut })
        .to('.close', 0.2, { scale: 1, ease: Cubic.easeOut })
        .to(cercaBox, 0.4, { y: 0 }, '-=0.4');

    cerca.addEventListener('click', () => {
        cercaTL.reversed() ? cercaTL.play() : cercaTL.reverse();
    })

    // Overlay
    var overlay = document.querySelector('.overlay'),
        triggers = document.querySelectorAll('.trigger-overlay'),
        close = document.querySelector('.close-overlay'),
        box = document.querySelector('.overlay-box');

    if(overlay) {
        var overlayTL = new TimelineMax({ paused: true })
            .set('body', { overflow: 'hidden' })
            .set(overlay, { pointerEvents: 'all' })
            .to(overlay, 0.3, { opacity: 1 })
            .to(box, 0.7, { opacity: 1, y: 0 }, '-=0.3')
            .to(close, 0.18, { scale: 1, ease: Back.easeOut.config(2) });

        for(var trigger of Array.from(triggers)) {
            trigger.addEventListener('click', () => {
                overlayTL.play();
            });
        }

        close.addEventListener('click', () => {
            overlayTL.reverse();
            $('.input-error').removeClass('input-error');
            $('.error').remove();
            $('#privacy-check').prop('checked', false);
            $('#invia').addClass('disabled');
            $('#inviaBuy').addClass('disabled');
        });
    }

    // Read more
    var readmore = document.querySelector('.readmore');

    if(readmore) {
        var lyrics = document.querySelector('.lyrics-box');
        readmore.addEventListener('click', () => {
            new TimelineMax()
                .set(lyrics, { height: 'auto', paddingBottom: 60 })
                .from(lyrics, 0.5, { height: 250 });
        })
    }


    // Audio Player
    var mediaBtns = document.querySelectorAll('.audio-control');
    if(mediaBtns.length > 1){
        TweenMax.set('.playpause', { pointerEvents: 'none' })
        for(var btn of Array.from(mediaBtns)){
            btn.addEventListener('click', (event) => {
                let _this = event.target || window.event;
                let track = _this.getAttribute('data-track');
                let trackToPlay = document.getElementById(track);
                if(_this.classList.contains('playing')) {
                    trackToPlay.pause();
                    TweenMax.set([trackToPlay, _this], { className: '-=playing'})
                } else {
                    var songs = document.getElementsByTagName('audio');
                    for( var song of Array.from(songs)){
                        if(song.classList.contains('playing')){
                            TweenMax.set([song, '.audio-control'], { className: '-=playing' })
                            song.pause();
                        }
                    }
                    trackToPlay.play();
                    TweenMax.set([trackToPlay, _this], { className: '+=playing'})
                }

            })
        }
    } else {
        Player();
    }


    // Switch
    var switchSearch = document.querySelector('.switch-search');
    var selectBox = document.querySelector('.select-box');
    var inputTypeBox = document.querySelector('.input_type_box');

    if(switchSearch){
        var fieldsBox = document.querySelectorAll('.fields-box');
        var baseSearch =
            (inputTypeBox.getAttribute('value') == 'base') ? true : false;
        switchSearch.addEventListener('click', () => {
            var showMe = document.querySelector('.showme');

            // change search type
            baseSearch = !baseSearch;

            for(var field of Array.from(fieldsBox)) {
                if(field.classList.contains('showme')){
                    //
                } else {
                    field.classList.add('hideme');
                }
            }

            // change label button and clear form
            if(baseSearch) {
                switchSearch.innerHTML = 'Advanced Search';
                inputTypeBox.setAttribute('value', 'base');
            } else {
                switchSearch.innerHTML = 'Return to base search';
                inputTypeBox.setAttribute('value', 'advanced');
            }

            new TimelineMax()
                .to(fieldsBox, 0.2, { height: 0 })
                .set(fieldsBox, { className: '+=showme' })
                .set(showMe, { className: '-=showme' })
                .set('.hideme', { height: 'auto', clearProps: 'all' })
                .to('.hideme', 0.3, {
                    height: 'auto',
                    onComplete: function() {
                        if(selectBox.classList.contains('opened')) {
                            TweenMax.set(['.select-wrapper', '.trigger-select', '.select-box', '.select-option'], { clearProps: 'all' })


                        }
                        new TimelineMax()
                            .set('.hideme', { className: '+=showme' })
                            .set('.hideme', { className: '-=hideme' })
                    }
                })
        })
    }

    var selectTag = document.querySelectorAll('.select-box .trigger-select');
    for(var select of Array.from(selectTag)){
        select.addEventListener('click', (e) => {
            e.preventDefault();
            var _this = e.target.parentNode || window.event;
            SelectBox(_this);
        })
    }


    $('#tags').flexdatalist({
        minLength: 1,
        searchContain: true
    });

    $('#birthdate').mask('0000-00-00');

    let download = document.querySelector('.download');
    let contratto_link = document.querySelector('.contratto_link');
    if(download){
        let contratto = document.querySelector('.contratto'),
            brano = document.querySelector('.mp3'),
            error = download.querySelector('.msg');

        let downBtn = download.querySelector('.btn'),
            contractBtn = contratto.querySelector('.btn'),
            branoBtn = brano.querySelector('.btn');

        downBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if(contratto.classList.contains('disabled')){
                contratto.classList.remove('disabled');
            }
        })
        branoBtn.addEventListener('click', (e) => {
            setTimeout(function() {
                let txt = brano.querySelector('.txt');
                txt.innerHTML = 'Download completato';
                txt.style['font-size'] = '30px';
                let bars = download.querySelector('.bars');
                bars.style.opacity = 0;
            }, 900);
        });
        contractBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if(brano.classList.contains('disabled')){
                contratto_link.innerHTML = 'Loading...';

                let link = document.createElement('a');
                link.href = contratto_link.getAttribute('data-url');
                link.setAttribute('target','_blank');
                var fileName = 'licence_song.pdf';
                link.download = fileName;
                if (document.createEvent) {
                    let e = document.createEvent('MouseEvents');
                    e.initEvent('click', true, true);
                    link.dispatchEvent(e);

                    setTimeout(function() {
                        brano.classList.remove('disabled');
                        contratto.setAttribute('style', 'display: none');
                    }, 800);
                }

            }
        })

    }


    /* Contact form handler */
    let contactForm = $('.contact-form'),
        errors = $('.input-error');

    var privacyCheck = $('#privacy-check');
    privacyCheck.on('change', function() {
        if(privacyCheck.is(':checked')){
            $('.btn').removeClass('disabled');
        } else {
            $('.btn').addClass('disabled');
        }

    });

    var privacyCheckBuy = $('#privacy-check-buy');
    var termsandconditionsCheckBuy = $('#termsandconditions-check-buy');

    privacyCheckBuy.on('change', function() {
        if(termsandconditionsCheckBuy.is(':checked') && privacyCheckBuy.is(':checked')){
            $('.btn').removeClass('disabled');
        } else {
            $('.btn').addClass('disabled');
        }

    });
    termsandconditionsCheckBuy.on('change', function() {
        if(termsandconditionsCheckBuy.is(':checked') && privacyCheckBuy.is(':checked')){
            $('.btn').removeClass('disabled');
        } else {
            $('.btn').addClass('disabled');
        }
    });

    if(errors.length) {
        errors.each(function() {
            $(this).on('input', () => {
                $(this).removeClass('input-error');
                $(this).parent().find('.error').remove();
            })
        })
    }

    var confirmMessage = $('.confirm-message');
    if(confirmMessage.length) {
        setTimeout(function() {
            new TimelineMax()
                .to(confirmMessage.find('.txt'), 0.4, { opacity: 1 })
                .to(confirmMessage, 0.4, {
                    transformOrigin: 'center top',
                    scaleY: 0,
                    onComplete: function() {
                        confirmMessage.remove();
                    }
                })
        }, 6000)
    }


});



// WEBPACK FOOTER //
// ./resources/js/index.js